import { toast } from "react-toastify";

export const Notify = (m, t) => toast(m, { position: "top-right", type: t });

export const generateUniqueRandomString = (length) => {
  const alphanumeric =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * alphanumeric.length);
    result += alphanumeric.charAt(randomIndex);
  }
  const timestamp = new Date().getTime();
  result += timestamp.toString();
  return result;
};
